import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { reportsRoutes } from './routes'
import { reportsPath } from './index'
import {
  toRelativeRoute,
  wrapRoutesWithRouter,
} from '../shared/utils/routerPaths'

const wrappedReportsRoutes = wrapRoutesWithRouter(reportsRoutes)
import { ReportsLayout } from './ReportsLayout'
import { ImiSidePanelProvider } from './context/ImiSidePanelContext'
import { AppLayoutDahboardWithNav } from '../shared/layouts'
import { ErrorBoundary } from '../shared/components/ErrorBoundary'
import { ErrorFallback } from '../shared/components/ErrorFallback'
import { DriversProvider } from '../shared/context/drivers/DriversContext'
import { TaskProvider } from '../shared/context/TaskContext'
import { PermissionGuard } from '@/modules/shared/components/NoPermission'
import { moduleAccess } from '@/modules/shared/permissions'

const ReportsModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary
      fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
    >
      <TaskProvider>
        <DriversProvider>
          <AppLayoutDahboardWithNav>
            <ErrorBoundary
              fallback={(e) => (
                <ErrorFallback error={e.error} onRetry={e.reset} />
              )}
            >
         
              <PermissionGuard companyId={companyId} {...moduleAccess.exports}>
              <ImiSidePanelProvider>
                <Routes>
                  {wrappedReportsRoutes.map((route) => (
                    <Route
                      key={route.path}
                      path={`${toRelativeRoute(route.path, reportsPath)}/*`}
                      element={
                        <ReportsLayout
                          companyId={companyId!}
                          // viewControlBar={route.viewControlBar}
                          heightScreen={route.heightScreen}
                          hideSidePanel={!route.imiSidePanel}
                        >
                          <route.Component />
                        </ReportsLayout>
                      }
                    />
                  ))}

                  {/* fallback */}
                  <Route
                    path="*"
                    element={
                      <ReportsLayout companyId={companyId!} hideSidePanel>
                        <div>Select</div>
                      </ReportsLayout>
                    }
                  />
                </Routes>
              </ImiSidePanelProvider>
              </PermissionGuard>
            </ErrorBoundary>
          </AppLayoutDahboardWithNav>
        </DriversProvider>
      </TaskProvider>
    </ErrorBoundary>
  )
}

export const ReportsModule = ReportsModuleImpl
